import tokenService from '@/services/auth/token.service';
import mapHelper from '../../common/map-helper';
import types from '@/store/modules/common/mutation-types-core'

import Vue from 'vue';

const state = () => ({
    token: null,
    refreshToken: null,
    login: null,
    expired: false,
    usuario: null,
    dependencia: {},
    permisosPrincipal: {},
    sistemaPrincipal: null
})

const getters = {
    getUser: state => state.username,
    getToken: state => state.token,
    getRefreshToken: state => state.refreshToken,
    getExpired: state => state.expired,
    getUsuario: state => state.usuario,
    getPermisos: state => state.usuario ? state.usuario.permisos : [],
    getPermisosPrincipal: state => state.usuario ? state.permisosPrincipal : [],
    getIntegrado: state => state.usuario ? state.usuario.integrado : [],
    getDependencia: state => state.dependencia,
    getSistemaPrincipal: state => state.sistemaPrincipal
}

const actions = {
    // funcion para activacion de cta nueva. adquiere token sin usuario
    async client_credentials({ dispatch }, state) {
        try {
            let response = await tokenService.client_credentials();
            if (response.data) {
                let userSession = {
                    token: response.data.token
                }
                dispatch(mapHelper.mapfn.setAuth, userSession);
            }

            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },
    async setAuth({ commit, dispatch }, userSession) {
        const { token, refreshToken } = userSession

        commit(types.SET_TOKEN, token)
        commit(types.SET_REFRESH_TOKEN, refreshToken)
        commit(types.SET_EXPIRED, false)


        if (token) {
            Vue.prototype.$session.start()
            Vue.prototype.$session.set('token', token);
            // Vue.prototype.$session.set('login', login);
            Vue.prototype.$session.set('refreshToken', refreshToken);
            Vue.prototype.$session.set('expired', false);
            // BUSCAR USUARIO
            dispatch(mapHelper.mapfn.buscarUsuario, { idsubsistema: Vue.prototype.$idsubsistema, sistemaPrincipal: Vue.prototype.$sistemaPrincipal });
        }

    },
    logOut({ commit }) {
        Vue.prototype.$session.destroy();
        // commit(types.SET_LOGIN,null)
        commit(types.SET_TOKEN, null)
        commit(types.SET_REFRESH_TOKEN, null)
        commit(types.SET_EXPIRED, false)
    },
    async logIn({ dispatch }, userSession) {
        const { login, password } = userSession
        try {
            let response = await tokenService.iniciarSesion(login, password)
            // let response = await tokenService.buscarUsuario(login,idUsuario),
            if (response.data) {

                let userSession = {
                    // login:response.data.login,
                    refreshToken: response.data.refresh_token,
                    token: response.data.token
                }

                dispatch(mapHelper.mapfn.setAuth, userSession);
            }


        } catch (error) {
            throw new Error(error.message)
        }
    },
    async setUsuario({ commit }, usuario) {
        Vue.prototype.$session.set('usuario', usuario);
        if(!usuario.esUsuarioIntegrado)
        localStorage.setItem('SIGHA-Dep-A-26',JSON.stringify({"id":usuario.integrado[0].idDependencia,"text":usuario.integrado[0].descripcion}));
        commit(types.SET_USUARIO, usuario)
    },
    async setPrincipal({ commit }, permisosPrincipal) {
        Vue.prototype.$session.set('permisosPrincipal', permisosPrincipal);
        commit(types.SET_PRINCIPAL, permisosPrincipal)
    },
    async setSistemaPrincipal({ commit }, sistemaPrincipal) {
        Vue.prototype.$session.set('sistemaPrincipal', sistemaPrincipal);
        commit(types.SET_SISTEMA_PRINCIPAL, sistemaPrincipal)
    },
    async buscarUsuario({ dispatch }, { idsubsistema, sistemaPrincipal }) {
        // const {login,password} = userSession
        dispatch(mapHelper.mapfn.setSistemaPrincipal, sistemaPrincipal);
        try {
            let response = await tokenService.obtenerUsuario(idsubsistema)
            if (response.data) {
                dispatch(mapHelper.mapfn.setUsuario, response.data);
                dispatch(mapHelper.mapfn.setPrincipal, response.data.permisos);
            }
        } catch (error) {
            throw new Error(error.message)
        }
    },
    async refreshToken({ dispatch, getters }) {

        try {
            let response = await tokenService.obtenerRefreshToken(getters.getRefreshToken)
            if (response.data) {

                let userSession = {
                    refreshToken: response.data.refresh_token,
                    token: response.data.token
                }

                dispatch(mapHelper.mapfn.setAuth, userSession);
            }
            return response

        } catch (error) {
            throw new Error(error.message)
        }
    },
    async cambioIdDependencia({ commit }, dependencia) {
        commit(types.SET_DEPENDENCIA, dependencia)
    },
    setExpired({ commit }) {
        Vue.prototype.$session.destroy();
        commit(types.SET_LOGIN, null)
        commit(types.SET_TOKEN, null)
        commit(types.SET_REFRESH_TOKEN, null)
        commit(types.SET_EXPIRED, true)
        commit(types.SET_USUARIO, null)
    },
    async setDatosSesion({ commit }) {

        // if (!state.usuario || !state.token) {

        //     let usuario = Vue.prototype.$session.get('usuario')
        //     let token = Vue.prototype.$session.get('token')
        //     let refreshToken = Vue.prototype.$session.get('refreshToken')
        //     let expired = Vue.prototype.$session.get('expired')
        //     let permisosPrincipal = Vue.prototype.$session.get('permisosPrincipal')
        //     let sistemaPrincipal = Vue.prototype.$session.get('sistemaPrincipal')

        //     if (token && !usuario) {
        //         try {
        //             let response = await tokenService.obtenerUsuario(Vue.prototype.$idsubsistema)
        //             if (response.data) {
        //                 usuario = response.data
        //                 permisosPrincipal = response.data.permisos
        //             }
        //         } catch (error) {
        //             throw new Error(error.message)
        //         }
        //     }

        //     commit(types.SET_TOKEN, token)
        //     commit(types.SET_REFRESH_TOKEN, refreshToken)
        //     commit(types.SET_EXPIRED, expired)
        //     commit(types.SET_USUARIO, usuario)
        //     commit(types.SET_PRINCIPAL,permisosPrincipal)
        //     commit(types.SET_SISTEMA_PRINCIPAL,sistemaPrincipal)

        //     state.usuario = usuario
        //     state.token = token
        //     state.refreshToken = refreshToken
        //     state.expired = expired
        //     state.permisosPrincipal = permisosPrincipal
        //     state.sistemaPrincipal = sistemaPrincipal

        // }

        let usuario = Vue.prototype.$session.get('usuario')
        let token = Vue.prototype.$session.get('token')
        let refreshToken = Vue.prototype.$session.get('refreshToken')
        let expired = Vue.prototype.$session.get('expired')
        let permisosPrincipal = Vue.prototype.$session.get('permisosPrincipal')
        let sistemaPrincipal = Vue.prototype.$session.get('sistemaPrincipal')

        if (token) {
            try {
                let response = await tokenService.obtenerUsuario(Vue.prototype.$idsubsistema)
                if (response.data) {
                    usuario = response.data
                    permisosPrincipal = response.data.permisos
                }
            } catch (error) {
                throw new Error(error.message)
            }
        }

        commit(types.SET_TOKEN, token)
        commit(types.SET_REFRESH_TOKEN, refreshToken)
        commit(types.SET_EXPIRED, expired)
        commit(types.SET_USUARIO, usuario)
        commit(types.SET_PRINCIPAL, permisosPrincipal)
        commit(types.SET_SISTEMA_PRINCIPAL, sistemaPrincipal)

        state.usuario = usuario
        state.token = token
        state.refreshToken = refreshToken
        state.expired = expired
        state.permisosPrincipal = permisosPrincipal
        state.sistemaPrincipal = sistemaPrincipal

    },

}

const mutations = {
    [types.SET_LOGIN](state, login) {
        state.login = login
    },
    [types.SET_TOKEN](state, token) {
        state.token = token
    },
    [types.SET_REFRESH_TOKEN](state, refreshToken) {
        state.refreshToken = refreshToken
    },
    [types.SET_EXPIRED](state, expired) {
        state.expired = expired
    },
    [types.SET_USUARIO](state, usuario) {
        state.usuario = usuario
    },
    [types.SET_DEPENDENCIA](state, dependencia) {
        state.dependencia = dependencia
    },
    [types.SET_PRINCIPAL](state, permisosPrincipal) {
        state.permisosPrincipal = permisosPrincipal
    },
    [types.SET_SISTEMA_PRINCIPAL](state, sistemaPrincipal) {
        state.sistemaPrincipal = sistemaPrincipal
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}